import { render } from "./CheckoutWhiteWhatYouGet.vue?vue&type=template&id=60e4bfc4&scoped=true"
import script from "./CheckoutWhiteWhatYouGet.vue?vue&type=script&lang=js"
export * from "./CheckoutWhiteWhatYouGet.vue?vue&type=script&lang=js"

import "./CheckoutWhiteWhatYouGet.vue?vue&type=style&index=0&id=60e4bfc4&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e4bfc4"]])

export default __exports__